export default __webpack_public_path__ + "static/media/KZ.T.15.2500.2253cd4d.svg";